import callApi, { CallApiResult } from '.';

export const getOrderingNoteSubjects = (): Promise<CallApiResult> => {
    const endpoint = '/api/ordering/noteSubject/list';
    return callApi(endpoint);
};

export const updateOrderingNoteSubject = (noteSubject: { id: string; subject: string }): Promise<CallApiResult> => {
    const endpoint = '/api/ordering/noteSubject/update';
    return callApi(endpoint, { method: 'PUT', data: noteSubject });
};

export const deleteOrderingNoteSubject = (id: string): Promise<CallApiResult> => {
    const endpoint = `/api/ordering/noteSubject/delete/${id}`;
    return callApi(endpoint, { method: 'DELETE' });
};

export const addOrderingNoteSubject = (noteSubject: { subject: string }): Promise<CallApiResult> => {
    const endpoint = '/api/ordering/noteSubject/add';
    return callApi(endpoint, { method: 'POST', data: noteSubject });
};
